import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import { Store } from '../store'

/**
 * Tool bar for editing the org chart
 */
@ngCore.Component({
  imports: [ds.button.Component, ds.overlay.confirmation.Component],
  selector: 'atn-summit-org-chart-tools',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link Store} */
  public readonly store = ngCore.inject(Store)

  /**
   * Controls the confirmation dialog for clearing the org chart
   */
  public readonly confirmClearSg = ngCore.signal(false)
}
